import { IEnvironment } from "../app/models/interfaces/environment-data";
import { environmentConfig } from "./environment.config";

const envConfig = environmentConfig.prod.external;

export const environment: IEnvironment = {
    EXTERNAL: true,
    IS_MOCKED: false,
    DEPLOYMENT: 'production',
    ANGULAR_ENV: envConfig.angularEnv,
    PW3_API: envConfig.phcRegionlessHostUrl + '/pw3-portfolio-health-check-api/api',
    CHART_DATA_ECS_URL: envConfig.regionlessHostUrl + '/pw2-portfolio-watch-webservice/portfoliowatch/chart-data?poid=VG-CLIENT-POID&viewID=VIEWID&accountGroup=ACCOUNTGROUP',
    LOGGER_URL: envConfig.regionlessHostUrl + '/pw2-portfolio-watch-webservice/log',
    GATEKEEPER_PW2_API: envConfig.regionlessHostUrl + '/pw2-portfolio-watch-webservice/portfoliowatch/toggle-switch?toggleId={{toggleid}}',
    FOCUS_PANEL_GET_SELECTED_GROUP: envConfig.regionlessHostUrl + '/ag3-account-grouping-consumer-api/getSelectedGroup',
    TEALEAF_LIB: envConfig.regionlessEcsUrl + '/xs1-secure-site-consumer-api/tealeaf',
    CONSUMER_API: envConfig.regionlessEcsUrl + '/xs1-secure-site-consumer-api/',
    AEM: 'https://pi.aemgraphql.vanguard.com/graphql/execute.json/portfolio-analysis/portfolio-watch-combined-content',
    VGN_HEADER_FOOTER_JS: 'https://n4v.web.vanguard.com/secure-site-components.js',
    VGN_HEADER_FOOTER_STYLE: 'https://n4v.web.vanguard.com/nav-preload.css',
    ADOBE_TARGET_ANTIFLICKER_JS: 'https://corp-at2.web.vanguard.com/antiflicker_v1/antiflicker.min.js',
    PORTFOLIO_WATCH: 'https://portfoliowatch.web.vanguard.com/',
    GREETINGS_WIDGET_ELEMENT_JS: "https://dashboard.web.vanguard.com/build/web-components.esm.js",
    FOCUS_PANEL_ELEMENT_JS: 'https://panel.cdn.web.vanguard.com/secure-site-panel/secure-site-panel.esm.js',
    ModernizedCustomizeView: 'https://customize-view.cdn.web.vanguard.com/',
    LOGON_URL: 'https://logon.vanguard.com/logon',
    c3Source: "https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js",
    c3Config: `const cccConfig = {
        site: 'retailInternal' ,
        rte: 'PROD',
        app: 'PW5',
        concerns: 'al,adl,it,adv4,cob',
        appConfig: {
            appdynamicskey: "AD-AAB-ABU-EPX",
        }
    };

    window.c3bundle && c3bundle.loadC3Bundle(cccConfig);`,
}